import routes from '@/modules/cities/citiesRegions-routes';
import store from '@/modules/cities/citiesRegions-store';

export default {
  routes,
  store
};
